import { Vue, Component } from "vue-property-decorator";
import ListForm from "@/views/votes/list/form";

@Component({
  props: {
    data: {
      required: true
    }
  },
  components: {
    "c-list-form": ListForm
  }
})
export default class EntriesForm extends Vue {
  list = {
    items: []
  };

  handleGetList(data) {
    this.data.items = [data];
  }

  async showListSelect() {
    if (!this.list.items[0]) {
      this.list = await this.getList();
    }
    this.$refs.listSelect.show();
  }

  handleSelect(items) {
    if (items[0]) {
      this.data.items.splice(0, 1, items[0]);
    }
  }

  getList() {
    return this.$store.dispatch(`votes/getList`, {
      query: {}
    });
  }
}
